import React from 'react';

import { Alert, Descriptions, Typography } from 'antd';

import { useFormikContext } from 'formik';
import { CurrencyId } from 'v2/interfaces/financial';
import type { INewAccount } from 'v2/interfaces/financial';

const Resume = () => {
  const { values } = useFormikContext<INewAccount>();

  const accountWithDigit = () => `${values.account || ''}${values.account_digit ? `-${values.account_digit}` : ''}`;
  const agencyWithDigit = () => `${values.agency || ''}${values.agency_digit ? `-${values.agency_digit}` : ''}`;

  function getAccountType(type: string) {
    const accountTypes = {
      CC: 'Conta Corrente',
      CP: 'Conta Poupança'
    };

    return accountTypes[type as keyof typeof accountTypes] || '';
  }

  const accountType = getAccountType(values.type);
  const isBRLSelected = values.currency === CurrencyId.BRL;
  const shouldDisplayAccountType = accountType && isBRLSelected;

  return (
    <div className='flex h-full flex-col justify-between gap-6'>
      <div className='flex flex-col gap-2'>
        <Typography.Title level={4} className='mb-0'>
          {values.name}
        </Typography.Title>
        <Typography.Text type='secondary'>{isBRLSelected ? 'BRL' : 'USD'}</Typography.Text>
        <div className='rounded-(--uizz-antd-border-radius-lg) bg-(--uizz-antd-color-fill-tertiary) p-4'>
          <Descriptions column={1} size='small'>
            <Descriptions.Item label='Banco'>{values.bank_id || ''}</Descriptions.Item>
            {values.operation_id !== 'not-selected' && values.operation_id && (
              <Descriptions.Item label='Operação'>{values.operation_id}</Descriptions.Item>
            )}
            <Descriptions.Item label='Agência'>{agencyWithDigit()}</Descriptions.Item>
            <Descriptions.Item label='Conta'>{accountWithDigit()}</Descriptions.Item>
            {shouldDisplayAccountType && <Descriptions.Item label='Tipo de conta'>{accountType}</Descriptions.Item>}
          </Descriptions>
        </div>
      </div>

      <Alert
        showIcon
        type='warning'
        message='Confirmação por e-mail'
        description={
          <>
            Ao clicar em finalizar você receberá um e-mail de confirmação que deve ser validado para conclusão do seu
            cadastro. Caso tenha alguma dúvida é só nos chamar no chat do menu de ajuda ou entrar em contato em{' '}
            <Typography.Text strong>suporte@eduzz.com</Typography.Text>.
          </>
        }
      />
    </div>
  );
};
export default Resume;
